module.exports = __webpack_public_path__ + "media/images/ajax-loader-9dd5e383.gif";